export const limitsChange = {
    allowZeroLimits: true,
};
